import { createContext, useContext, useMemo, useState } from "react";
import { MatchFilter } from "../libs/statsFilters";
import { useSettings } from "./SettingsProvider";

export interface FiltersProviderProps {
  children: React.ReactNode;
}

export type SyncMetadata = {
  id: string;
  matches: {
    lastSyncedAt: number;
    lastItemId?: string;
  };
  match_events: {
    lastSyncedAt: number;
    lastItemId?: string;
  };
};

type FiltersContextType = {
  active: MatchFilter;
  update: (newFilters: Partial<MatchFilter>) => void;
  reset: () => void;
  clear: () => void;
};

const FiltersContext = createContext<FiltersContextType | undefined>(undefined);

export const FiltersProvider: React.FC<FiltersProviderProps> = ({
  children,
}) => {
  const settings = useSettings();
  const [activeFilters, setActiveFilters] = useState<MatchFilter>({
    ...settings.globals.filters,
  });

  const value: FiltersContextType = useMemo(
    () => ({
      active: activeFilters,
      update: (newFilters) => {
        console.log("Updating active filters", newFilters);
        setActiveFilters((prevFilters) => ({
          ...prevFilters,
          ...newFilters,
        }));
      },
      reset: () => {
        setActiveFilters({ ...settings.globals.filters });
      },
      clear: () => {
        setActiveFilters({});
      },
    }),
    [activeFilters, settings.globals.filters]
  );

  return (
    <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
  );
};

// Custom hook to use IndexedDb
export const useFilters = (): FiltersContextType => {
  const context = useContext(FiltersContext);

  if (context == null) {
    throw new Error("useFilters must be used within a FiltersProvider");
  }

  return context;
};
